import BoostModal from './BoostModal';

export default BoostModal;
